module.exports = __webpack_public_path__ + "media/bet.e3d5fc04.mp3";